export default "__VITE_ASSET__DjBQBau7__"